import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {Component} from 'vue-property-decorator';
@Component({
    components: {},
})
export default class ClientFooterComponent extends VueWrapper {
    public $refs!: {};

    public currentYear = new Date().getFullYear();

    public mounted() {
        console.log('ClientFooterComponent mounted');
    }
}
